import type { CardId, Command } from "../../domain/types/index.js";

export type RewardChoice = { kind: "card"; cardId: CardId } | { kind: "recover" };

export function rewardRecoverLabel(size: string | undefined): string {
  if (size === "large") return "疲労を全回復";
  if (size === "medium") return "疲労を3回復";
  return "疲労を2回復";
}

export function rewardConfirmLabel(
  choice: RewardChoice | null,
  cardName: string | undefined,
  recoverLabel: string,
): string {
  if (!choice) return "選んでください";
  if (choice.kind === "recover") return `${recoverLabel}する`;
  return `${cardName ?? "このカード"}を取る`;
}

export function rewardCommand(choice: RewardChoice): Command {
  if (choice.kind === "recover") return { type: "CHOOSE_REWARD", cardId: "recover" };
  return { type: "CHOOSE_REWARD", cardId: choice.cardId };
}
